import React, { useEffect } from 'react';

const Widget = () => {
  const WIDGET_URL = 'https://deli-widget.surge.sh/deli.js';

  useEffect(() => {
    const script = document.createElement('script');
    script.src = WIDGET_URL;
    script.async = true;

    script.onload = () => {
      console.log("Script loaded successfully");
      if (typeof DeliWidget !== 'undefined' && typeof DeliWidget.init === 'function') {
        DeliWidget.init({
          brand: "Nathans testing widget client",
          widget_key: "6f4e7a59-e05d-43c8-80c6-0c61d928b9b1",
          logo: "https://honeycombrealty.com/wp-content/uploads/2024/02/honeycomb_horizontal-logo.png",
          color: "#f6b73c"
        });
      } else {
        console.error("DeliWidget or DeliWidget.init is not defined");
      }
    };

    script.onerror = () => {
      console.error("Failed to load the script");
    };

    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return <></>;
};

export default Widget;
